// src/contexts/CartContext/CartContext.js
import { createContext, useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [cartItemCount, setCartItemCount] = useState(0);

  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const order = JSON.parse(localStorage.getItem(orderKey));

  useEffect(() => {
    if (order) {
      if (isFringeBenefitsPage) {
        setCartItemCount(1);
        setCart([order]);
        return;
      }

      setCartItemCount(order?.itens.length);
      setCart(order?.itens);
    }
  }, []);

  useEffect(() => {
    setCartItemCount(cart.length);
  }, [cart]);

  const addItemToCart = useCallback(
    (item) => {
      setCart((prevCart) => [...prevCart, item]);
    },
    [cart]
  );

  const removeItemFromCart = useCallback(
    (item) => {
      setCart((prevCart) => prevCart.filter((i) => i.product.id !== item.product.id));
    },
    [cart]
  );

  const removeFringeBenefitItemFromCart = useCallback(
    (item) => {
      setCart([]);
    },
    [cart]
  );

  return (
    <CartContext.Provider
      value={{
        cart,
        cartItemCount,
        addItemToCart,
        removeItemFromCart,
        removeFringeBenefitItemFromCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
